






















































































































































import { Vue, Component } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { OktaSignInWidgetBuilder } from "@/shared/oktaSignInWidgetWrapper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useSignUpStore } from "@/employee/store/signup";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { useThemeStore } from "@/shared/store/theme";
import passwordValidation from "@/shared/passwordValidation";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";

@Component({
  components: {
    HsaBankOnboardingFooter,
    Button,
    LoginWrapper,
    GenericLoadingSpinner
  }
})
export default class LoginInfo extends Vue {
  $validator: Validator;
  signupStore = useSignUpStore();
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  themeStore = useThemeStore();

  isProcessing = false;
  password = "";
  confirmPassword = "";
  username = "";
  showStartOverButton = false;
  widget = new OktaSignInWidgetBuilder("#okta-signin-container-auto-login");
  revealPassword = false;
  revealConfirmPassword = false;
  isSubmitting = false;

  get submitDisabled () {
    return this.isSubmitting;
  }

  get invalidState (): boolean {
    return !this.signupStore.isEmailVerified || this.signupStore.bendUserId === "" || this.signupStore.bendUserId === undefined;
  }

  get confirmPasswordValidation () {
    return {
      required: !!this.password,
      confirmed: !!this.confirmPassword && this.password
    };
  }

  get passwordValidation () {
    return {
      length: [12, 40],
      atLeastOneUppercase: true,
      atLeastOneLowercase: true,
      atLeastOneNumber: true,
      noWhitespace: true,
      doesNotContain: this.username
    };
  }

  pwReqMet (rule: string, defaultValue = false) {
    if (!this.password) {
      return defaultValue;
    }

    return !this.errors.firstByRule("password", rule);
  }

  onSubmit () {
    this.isSubmitting = true;

    this.validateAll()
      .then(isValid => {
        this.isSubmitting = false;

        if (!isValid) {
          return;
        }

        return this.submitCreateLoginRequest();
      })
      .catch(() => {
        this.isSubmitting = false;
      });
  }

  validateAll () {
    return this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return Promise.resolve(false);
        }

        return passwordValidation.validate(this.password);
      })
      .catch(error => {
        let message = "Please choose another password.";

        if (error && error.message) {
          message = error.message;
        }

        this.notifierStore.setDanger(message);

        return Promise.resolve(false);
      });
  }

  submitCreateLoginRequest () {
    this.isProcessing = true;
    this.showStartOverButton = false;

    return this.signupStore.individualSignupCreateLogin({
        bendUserId: this.signupStore.bendUserId,
        signature: this.signupStore.signature,
        username: this.username,
        password: this.confirmPassword
      })
      .then(() => this.signIn())
      .catch(() => {
        this.isProcessing = false;
        this.showStartOverButton = true;
      });
  }

  signIn () {
    this.widget
    .buildForLoginWithoutPrompt(this.username, this.password)
    .showSignInAndSetTokens()
    .then(() => this.userStore.postLogin())
    .catch(() => {
      this.isProcessing = false;
      this.userStore.logout();
      this.userStore.setLoginUsername(this.username);
      this.$router.push({ name: LoginRouteNames.OktaLogin });
      this.notifierStore.setDanger("Unable to login, please try again");
    });
  }

  togglePasswordMask () {
    this.revealPassword = !this.revealPassword;
  }

  toggleConfirmPasswordMask () {
    this.revealConfirmPassword = !this.revealConfirmPassword;
  }

  destroyed () {
    this.widget.destroyed();
  }
}
